import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { useState, useEffect } from "react";

import Home from "./pages/Home";
import Activities from "./pages/Activities";
import Join from "./pages/Join";
import "./App.css";

function App() {
  const [fadeOut, setFadeOut] = useState(false);
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFadeOut(true), 3000); // 3秒後フェードアウト
    const hideTimer = setTimeout(() => setShowSplash(false), 3500); // フェードアウト後非表示
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(hideTimer);
    };
  }, []);

  return (
    <Router>
      {/* スプラッシュ画面 */}
      {showSplash && (
        <div className={`splash-screen ${fadeOut ? "fade-out" : ""}`}>
          <h1>東京海洋大学</h1>
          <h2>Tokyo University of Marine Science and Technology</h2>
          <h1>ロボット研究会</h1>
          <h2>Robot nokotosiraberukai</h2>

        </div>
      )}

      {/* ページ全体のレイアウト */}
      <div className="layout">
        {/* サイドメニュー */}
        <aside className="side-menu">
          <ul className="menu-list">
            <li>
              <Link to="/" className="menu-link home-link"></Link>
            </li>
            <li>
              <Link to="/activities" className="menu-link"><span>活動内容</span></Link>
            </li>
            <li>
              <Link to="/join" className="menu-link"><span>部長のお言葉</span></Link>
            </li>
          </ul>
        </aside>

        {/* メインコンテンツ */}
        <main className="content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/activities" element={<Activities />} />
            <Route path="/join" element={<Join />} />
          </Routes>

          <footer>
            <p>© 2025 ロボット研究会</p>
          </footer>
        </main>
      </div>
    </Router>
  );
}

export default App;
